// Keeps Stripe.js's iframes out of Turbo's page cache.
//
// Stripe.js lives as long as the document, not the page: after a Turbo visit
// away from a checkout it re-attaches its controller and Payment Element frames
// ("loader-ui" among them) to the NEXT page's <body>. Turbo then snapshots that
// page with clones of those frames, and restoring the snapshot — Back, or a
// visit that shows the cached preview — reloads the clones. The still-running
// Stripe.js does not recognise them and throws "loaderUi Element didn't mount
// normally" (LUC-909: ws 607, on the second visit to number series, 14 s after
// leaving the checkout).
//
// Marking every Stripe frame data-turbo-temporary right before a snapshot makes
// Turbo's own cache observer remove it, so no snapshot carries one. The page
// being left loses them a moment before its body is swapped out anyway. Pages
// that mount a Payment Element are exempt from the cache altogether
// (billing/checkout_controller.js), so a live form is never touched.
//
// Matched by host and, in case a frame is ever served from another Stripe host,
// by the name prefix Stripe.js gives every frame it attaches.
const STRIPE_FRAMES = 'iframe[src^="https://js.stripe.com/"], iframe[name^="__privateStripe"]'

let installed = false

// Idempotent: call it wherever Stripe.js is loaded.
export function keepStripeFramesOutOfTurboCache() {
  if (installed) return
  installed = true

  // On document, so it runs before Turbo's own listener on window removes the
  // temporary elements.
  document.addEventListener("turbo:before-cache", () => {
    for (const frame of document.querySelectorAll(STRIPE_FRAMES)) frame.setAttribute("data-turbo-temporary", "")
  })
}
